import { useLocation } from 'react-router-dom';

/** Hook that returns true if the page is the interstitials page (aka /ecom/beforeYouGo) */
export function useIsBeforeYouGo() {
  const location = useLocation();

  return /^\/ecom\/beforeYouGo/i.test(location.pathname);
}
